// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"137":"31d6cfe0","241":"480fcf06","454":"11c8aeed","940":"52e30265"}[chunkId] + ".chunk.css";
};